var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H19.25C19.6642 0 20 0.335786 20 0.75C20 1.16421 19.6642 1.5 19.25 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.75C0 7.33579 0.335786 7 0.75 7H19.25C19.6642 7 20 7.33579 20 7.75C20 8.16421 19.6642 8.5 19.25 8.5H0.75C0.335786 8.5 0 8.16421 0 7.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.75C0 14.3358 0.335786 14 0.75 14H19.25C19.6642 14 20 14.3358 20 14.75C20 15.1642 19.6642 15.5 19.25 15.5H0.75C0.335786 15.5 0 15.1642 0 14.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger_icon.76cc6ca9c6d2da8c9b4e209da6d366cd.svg";
export { ForwardRef as ReactComponent };